import React from "react"


const App =() =>{
    let total =0;
    const click = e =>{

        if (typeof window !== undefined){
            let t=0;
            if(localStorage.getItem("total")){
                t = JSON.parse(localStorage.getItem("total"));
            }
            console.log("1",total)
            total=t+1
            localStorage.setItem("total", JSON.stringify(total))
        }
    }

    const SignUp = (total) =>{
        let t;
        if (typeof window !== undefined){
            if(localStorage.getItem("total")){
                t = JSON.parse(localStorage.getItem("total"));
                total = t
            }
        }
        console.log(total)
        return(
                <div className="container mx-6" style={{ display: total%2 !== 0 ? "" : "none"}}>
                    <h1>SignUp Here</h1>
                    <form>
                        <div className="input">
                            <input type="text" placeholder="Email" />
                        </div>
                        <div className="input">
                            <input type="text" placeholder="Username" />
                        </div>
                        <div className="input">
                            <input type="password" placeholder="Password" />
                        </div>
                        <button className="btn btn-outline-success btn-"><p>Signup</p></button>
                    </form>
                    <h4>Or</h4>
                    <h4>SignUp with</h4>
                    <p><ion-icon size="large" name="logo-facebook"></ion-icon><ion-icon size="large" name="mail-sharp"></ion-icon></p>
                </div>
        )
    }

    const signupbtn = () =>{
        let t;
        if (typeof window !== undefined){
            if(localStorage.getItem("total")){
                t = JSON.parse(localStorage.getItem("total"));
                total = t
            }
        }
        return(
            <div>
                <h3 style={{ display: total%2 === 0 ? "" : "none"}}>Don't have an account!</h3>
                <form style={{ display: total%2 === 0 ? "" : "none"}}>
                    <button className="btn btn-outline-success " onClick={click}>Signup</button>
                </form>
            </div>
        )
    }

    const Login = (total) =>{
        let t;
        if (typeof window !== undefined){
            if(localStorage.getItem("total")){
                t = JSON.parse(localStorage.getItem("total"));
                total = t
            }
        }
        console.log(total)
        return (
            <div className="container " style={{ display: total%2 === 0 ? "" : "none"}}>            
                    <h1>Login Here</h1>
                    <form>
                        <div className="input">
                            <input type="text" placeholder="Email/Username" />
                        </div>
                        <div className="input">
                            <input type="password" placeholder="Password" />
                        </div>
                        <button className="btn btn-outline-success btn-"><p>Login</p></button>
                    </form>
                    <h4>Or</h4>
                    <h4>Login with</h4>
                    <p><ion-icon size="large" name="logo-facebook"></ion-icon><ion-icon size="large" name="mail-sharp"></ion-icon></p>
                </div>
        )
    }

    const loginbtn = () =>{
        let t;
        if (typeof window !== undefined){
            if(localStorage.getItem("total")){
                t = JSON.parse(localStorage.getItem("total"));
                total = t
            }
        }    
            
        return(
            <div>
                <h3 style={{ display: total%2 !== 0 ? "" : "none"}}>Already have an account!</h3>
                <form style={{ display: total%2 !== 0 ? "" : "none"}}>
                    <button className="btn btn-outline-success " onClick={click}>Login</button>
                </form>
            </div>
        )
        
    }

    return(
        <div className="row mx-auto">
            <h1 className="my-5">My Login and SignUp Page</h1>
            <div className="col-6  mx-auto">
                {Login(total)}
                {loginbtn()}
            </div>
            <div className="col-6 mx-auto">
                {SignUp(total)}
                {signupbtn()}
            </div>
        </div>
    )
}

export default App;